/* RESPONSIBLE TEAM: team-ai-insights */

import { get } from 'embercom/lib/ajax';

export enum TrendingTopicImpact {
  Positive = 0,
  Negative = 1,
  Neutral = 2,
  Unknown = 3,
}

export enum TrendingTopicTimeTrend {
  IncreasingTrend = 0,
  DecreasingTrend = 1,
  Flat = 2,
  SingleWeekAnomaly = 3,
  Unknown = 4,
}

export interface TrendingTopic {
  subtopicName: string;
  topicName: string;
  timeTrend: TrendingTopicTimeTrend;
  weekStart: number;
  impact: TrendingTopicImpact;
  insightTitle: string;
  insightExplanation: string;
  outlierConversationIds: string[];
}

export interface TrendingTopicWireFormat {
  subtopic_name: string;
  topic_name: string;
  time_trend: number;
  week_start: number;
  impact: number;
  insight_title: string;
  insight_explanation: string;
  outlier_conversation_ids: string[];
}

async function fetchTrendingTopics(appId: any, useSyntheticData: boolean, signal?: AbortSignal) {
  try {
    let response = (await get(
      '/ember/ai_insights/trending_topics',
      {
        app_id: appId,
        synthetic_data: useSyntheticData,
      },
      { signal },
    )) as TrendingTopicWireFormat[];

    if (response.length === 0) {
      return [];
    }

    return response.map((topic) => ({
      subtopicName: topic.subtopic_name,
      topicName: topic.topic_name,
      timeTrend: topic.time_trend,
      weekStart: topic.week_start,
      impact: topic.impact,
      insightTitle: topic.insight_title,
      insightExplanation: topic.insight_explanation,
      outlierConversationIds: topic.outlier_conversation_ids,
    }));
  } catch (error) {
    return [];
  }
}

export { fetchTrendingTopics };
